var _rect, _rect2, _rect3, _path, _rect4, _rect5, _path2, _rect6, _rect7, _path3, _circle, _circle2, _circle3, _circle4, _circle5, _rect8, _rect9;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 814,
    height: 458,
    viewBox: "0 0 814 458",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 814,
    height: 458,
    fill: "#3C474D"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 271,
    y: 132,
    width: 285,
    height: 84,
    rx: 20,
    fill: "#2B353A"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 265,
    y: 125,
    width: 284,
    height: 84,
    rx: 24,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M290.625 154.375V180.625C290.625 182.688 292.294 184.375 294.375 184.375H320.625C322.688 184.375 324.375 182.688 324.375 180.625V154.375C324.375 152.312 322.688 150.625 320.625 150.625H294.375C292.294 150.625 290.625 152.312 290.625 154.375ZM313.125 161.875C313.125 164.988 310.612 167.5 307.5 167.5C304.387 167.5 301.875 164.988 301.875 161.875C301.875 158.762 304.387 156.25 307.5 156.25C310.612 156.25 313.125 158.762 313.125 161.875ZM307.5 171.062C303.75 171.062 296.25 173.125 296.25 176.875V178.75H318.75V176.875C318.75 173.125 311.25 171.062 307.5 171.062Z",
    fill: "#007BC1"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 363,
    y: 159,
    width: 40,
    height: 16,
    fill: "#80BDE0"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 435,
    y: 159,
    width: 68,
    height: 16,
    fill: "#80BDE0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M409 167C409 161.48 413.48 157 419 157C424.52 157 429 161.48 429 167V168.43C429 170.4 427.47 172 425.5 172C424.31 172 423.19 171.42 422.54 170.53C421.64 171.44 420.38 172 419 172C416.24 172 414 169.76 414 167C414 164.24 416.24 162 419 162C421.76 162 424 164.24 424 167V168.43C424 169.22 424.71 170 425.5 170C426.29 170 427 169.22 427 168.43V167C427 162.66 423.34 159 419 159C414.66 159 411 162.66 411 167C411 171.34 414.66 175 419 175H424V177H419C413.48 177 409 172.52 409 167ZM416 167C416 168.66 417.34 170 419 170C420.66 170 422 168.66 422 167C422 165.34 420.66 164 419 164C417.34 164 416 165.34 416 167Z",
    fill: "#268FCA"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 271,
    y: 256,
    width: 285,
    height: 84,
    rx: 20,
    fill: "#2B353A"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 265,
    y: 250,
    width: 284,
    height: 84,
    rx: 24,
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M318.75 285H316.875V281.25C316.875 276.075 312.675 271.875 307.5 271.875C302.325 271.875 298.125 276.075 298.125 281.25V285H296.25C294.188 285 292.5 286.688 292.5 288.75V307.5C292.5 309.562 294.188 311.25 296.25 311.25H318.75C320.812 311.25 322.5 309.562 322.5 307.5V288.75C322.5 286.688 320.812 285 318.75 285ZM307.5 301.875C305.438 301.875 303.75 300.188 303.75 298.125C303.75 296.062 305.438 294.375 307.5 294.375C309.562 294.375 311.25 296.062 311.25 298.125C311.25 300.188 309.562 301.875 307.5 301.875ZM301.875 281.25V285H313.125V281.25C313.125 278.138 310.612 275.625 307.5 275.625C304.387 275.625 301.875 278.138 301.875 281.25Z",
    fill: "#007BC1"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 372,
    cy: 292,
    r: 8,
    fill: "#4DA3D4"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 403,
    cy: 292,
    r: 8,
    fill: "#4DA3D4"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 434,
    cy: 292,
    r: 8,
    fill: "#4DA3D4"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 465,
    cy: 292,
    r: 8,
    fill: "#4DA3D4"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 496,
    cy: 292,
    r: 8,
    fill: "#4DA3D4"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 103,
    height: 458,
    fill: "#1D2529"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 711,
    width: 103,
    height: 458,
    fill: "#1D2529"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogin);
export default __webpack_public_path__ + "static/media/login.ddfb1d60e180c9c7cbd3d27a965b5b03.svg";
export { ForwardRef as ReactComponent };